<template lang="pug">
  form(@submit.prevent="onSubmit")
    modal(active title="Filtrar coleções" @close="$router.back()")
      .columns(slot="modal-body")
        .column.col-6.col-sm-12
          form-group(label="Título")
            input.form-input(v-model.trim="filter.title")
        .column.col-6.col-sm-12
          form-group(label="Resumo")
            input.form-input(v-model.trim="filter.brief")
        .column.col-12
          .form-group
            label.form-label Idioma
            label.form-radio
              input(type="radio" v-model="filter.language")
              i.form-icon 
              | Todas
            label.form-radio
              input(type="radio" value="pt" v-model="filter.language")
              i.form-icon 
              | Português
            label.form-radio
              input(type="radio" value="en" v-model="filter.language")
              i.form-icon 
              | Inglês
            label.form-radio
              input(type="radio" value="es" v-model="filter.language")
              i.form-icon 
              | Espanhol
      .text-right(slot="modal-footer")
        router-link.mr-2.btn.btn-link(:to="{ name: 'collections.list' }" replace v-if="filtered") Limpar filtros
        button.btn.btn-primary
          i.fas.fa-filter
          |  Filtrar
</template>

<script>
export default {
  data() {
    return { filter: {} }
  },
  computed: {
    filtered() {
      return JSON.stringify(this.filter) !== JSON.stringify({})
    },
  },
  methods: {
    onSubmit() {
      this.$router.replace({
        name: 'collections.list',
        query: { q: this.filter },
      })
    },
  },
  created() {
    const { q = {} } = this.$route.query
    this.filter = q
  },
}
</script>
